import { render } from "./ProjectsTable.vue?vue&type=template&id=32fe596f"
import script from "./ProjectsTable.vue?vue&type=script&lang=js"
export * from "./ProjectsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__